<button type="button" class="rpa-trigger-btn" (click)="openDialog()">
  <lucide-angular name="folder-key" class="rpa-trigger-btn-icon"></lucide-angular>
  <span>Request Project Access</span>
</button>
